import { compact } from 'lodash';

export function classnames(classList) {
    return compact(classList).join(' ');
}
